import React, { useState } from "react";
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { getApi, postApi, putApi } from "../AppApis"; // Adjust import path as needed
import { toast } from "react-toastify";

export default function UpgradePopup({ package_type, propertyDetails, navigate, onClose }) {
    const stripe = useStripe();
    const elements = useElements();
    console.log(propertyDetails);

    const [cardHolderName, setCardHolderName] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);
    const paymentAmount = package_type === "premium" ? "29" : package_type === "deluxe" ? "59" : "0.00";

    const [errors, setErrors] = useState({
        cardNumber: "",
        cardExpiry: "",
        cardCvc: "",
        zipCode: "",
    });
    const handleChange = (event, field) => {
        if (event.error) {
            setErrors((prev) => ({ ...prev, [field]: event.error.message }));
        } else {
            setErrors((prev) => ({ ...prev, [field]: event.complete ? "" : "This field is required" }));
        }
    };

    const updateSubscription = async () => {
        if (!cardHolderName) {
            toast.error("Please enter card holder name");
            return;
        }

        if (!zipCode) {
            toast.error("Please enter zip code");
            return;
        }

        if (!stripe || !elements) {
            toast.error("Stripe has not loaded yet");
            return;
        }
        let checkProration;
        if (propertyDetails?.package_type === "premium" && package_type === "deluxe") {
            console.log("HERE");
            checkProration = await getApi("/property-services/update_subscription_plan/" + propertyDetails.property_id);
        }

        setIsProcessing(true);

        try {
            const cardNumber = elements.getElement(CardNumberElement);

            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: "card",
                card: cardNumber,
            });

            const { token, errorToken } = await stripe.createToken(cardNumber);

            if (error) {
                toast.error(error.message);
                setIsProcessing(false);
                return;
            }

            const today = new Date();
            const nextBillingDate = new Date(today);
            nextBillingDate.setDate(today.getDate() + 30);
            const formattedNextBillingDate = nextBillingDate.toISOString().split("T")[0];

            let payload = {
                package_type: package_type,
                next_billing_date: formattedNextBillingDate,
                token: token.id,
                payment_amount: Number(paymentAmount),
                card_holder_name: cardHolderName,
                code: zipCode,
            };
            if (checkProration?.response && checkProration?.response?.data) {
                payload.proration_id = checkProration?.response?.data?.proration_id;
            }
            const url = `/property-services/update_subscription_plan/${propertyDetails?.property_id}`;
            const response = await putApi(url, payload);

            if (response?.error) {
                toast.error(response.error);
            } else {
                if (response?.response?.data?.note) {
                    toast.success(response?.response?.data?.note);
                } else {
                    toast.success("Subscription Updated Successfully");
                }
                navigate("/MyProperties");
                onClose();
            }
        } catch (error) {
            console.error("Subscription update error:", error);
            toast.error("Failed to update subscription. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            className="tw-fixed tw-z-50 tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-flex tw-items-center tw-justify-center"
        >
            <div className="tw-bg-white tw-rounded-lg tw-p-8 tw-max-w-md tw-w-full tw-mx-4">
                <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
                    <h2 className="tw-text-xl tw-font-bold tw-text-gray-800">
                        Upgrade to {package_type} Plan (${paymentAmount}/month)
                    </h2>
                    <button onClick={onClose} className="tw-text-gray-500 hover:tw-text-gray-700 tw-text-2xl" aria-label="Close">
                        &times;
                    </button>
                </div>

                <div className="tw-space-y-4">
                    <div>
                        <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">Cardholder Name</label>
                        <input
                            type="text"
                            value={cardHolderName}
                            maxLength={50}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Allow only letters and spaces
                                setCardHolderName(value);
                            }}
                            className="tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md"
                            placeholder="John Doe"
                        />
                    </div>

                    <div>
                        <div className="tw-mb-4">
                            <label className="tw-font-sans tw-text-sm tw-text-black tw-block tw-mb-2">Card Number</label>
                            <div className="tw-w-full tw-bg-white tw-py-3 tw-px-4 tw-border tw-rounded-md">
                                <CardNumberElement onChange={(event) => handleChange(event, "cardNumber")} />
                            </div>
                            {errors.cardNumber && <p className="tw-text-red-500 tw-text-sm">{errors.cardNumber}</p>}
                        </div>
                        <div className="tw-mb-4">
                            <label className="tw-font-sans tw-text-sm tw-text-black tw-block tw-mb-2">Expire</label>
                            <div className="tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-border tw-rounded-md">
                                <CardExpiryElement onChange={(event) => handleChange(event, "cardExpiry")} />
                            </div>
                            {errors.cardExpiry && <p className="tw-text-red-500 tw-text-sm">{errors.cardExpiry}</p>}
                        </div>
                        <div className="tw-mb-4">
                            <label className="tw-font-sans tw-text-sm tw-text-black tw-block tw-mb-2">CVC</label>
                            <div className="tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-border tw-rounded-md">
                                <CardCvcElement onChange={(event) => handleChange(event, "cardCvc")} />
                            </div>
                            {errors.cardCvc && <p className="tw-text-red-500 tw-text-sm">{errors.cardCvc}</p>}
                        </div>
                    </div>

                    <div>
                        <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">ZIP Code</label>
                        <input
                            type="text"
                            value={zipCode}
                            onChange={(e) => setZipCode(e.target.value)}
                            className="tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md"
                            placeholder="12345"
                            maxLength={5}
                        />
                    </div>
                </div>

                <div className="tw-flex tw-justify-end tw-space-x-3 tw-mt-6">
                    <button
                        onClick={onClose}
                        className="tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md hover:tw-bg-gray-50"
                        disabled={isProcessing}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={updateSubscription}
                        className="tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-rounded-md hover:tw-bg-blue-700 disabled:tw-bg-blue-400"
                        disabled={isProcessing || !stripe}
                    >
                        {isProcessing ? "Processing..." : "Upgrade Now"}
                    </button>
                </div>
            </div>
        </div>
    );
}
